export default
{
    key: 'actions',
    label: 'Acties',
    thClass: 'text-right',
    tdClass: 'text-right text-nowrap'
}